<div class="page-body" >
  <div class="row">
    <div class="col-sm-12">
      <app-card [advanceButton]="true"
                [advancedButtons]="specialButton"
                (outputButtonAdvance)="calFunction($event)"
                [title]="'global.overview'|translate">
        <app-grid [buttonViewChange]="true"  [grid]="grid"  (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
<ng-template #expectedDeliveryWeekTemp let-row="row" let-value="value" let-column="column">
  {{row.expectedDeliveryWeek ? (row.expectedDeliveryWeek|WeekDateFormat) : ''}}
</ng-template>

